import type { TFunction } from 'react-i18next';

export const approvalCopy = (t: TFunction) => ({
  changes: t('Changes to approve'),
  cardLabel: (summary: string) =>
    t('Approval request: {{summary}}', { summary }),
  apiName: t('api name'),
  /** The verb for a change the card has no words for, or several kinds of change. */
  change: t('Change'),
  composerLocked: t('Answer the approval request to continue'),
});

/**
 * kizen's plan actions, and the verbs some kinds mean (an archive is an
 * `update`), as labels; undefined for any other action, which the card
 * describes as a change instead of showing it as sent.
 */
export const approvalActionLabel = (
  t: TFunction,
  action: string
): string | undefined => {
  switch (action) {
    case 'create':
      return t('Create');
    case 'update':
      return t('Update');
    case 'delete':
      return t('Delete');
    case 'duplicate':
      return t('Duplicate');
    case 'upsert':
      return t('Create or update');
    case 'apply':
      return t('Apply');
    case 'skip':
      return t('Skip');
    case 'archive':
      return t('Archive');
    case 'unarchive':
      return t('Unarchive');
    case 'move':
      return t('Move');
    case 'import':
      return t('Import');
    default:
      return undefined;
  }
};
